import { render, staticRenderFns } from "./InstallmentBatchTypeCards.vue?vue&type=template&id=1a21b5e3&"
import script from "./InstallmentBatchTypeCards.vue?vue&type=script&lang=js&"
export * from "./InstallmentBatchTypeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports